import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

const EmptyScheduleDay = () => {
  return (
    <Box
      width="full"
      background="grey200"
      alignItems="center"
      justifyContent="center"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Text size="300" weight="medium" color="grey1000">
        -
      </Text>
    </Box>
  )
}

export default EmptyScheduleDay
